import { render, staticRenderFns } from "./AsociarClientesProveedor.vue?vue&type=template&id=f590f440&"
import script from "./AsociarClientesProveedor.vue?vue&type=script&lang=ts&"
export * from "./AsociarClientesProveedor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f590f440', component.options)
    } else {
      api.reload('f590f440', component.options)
    }
    module.hot.accept("./AsociarClientesProveedor.vue?vue&type=template&id=f590f440&", function () {
      api.rerender('f590f440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Informes/ContainerInformeDescargas/AsociarClientesProveedor.vue"
export default component.exports